import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import ReadTimeQuery, {
	type useReadTimeQuery$data,
	type useReadTimeQuery$variables,
} from './hooks/__generated__/useReadTimeQuery.graphql.ts';

type PreloadReadTimeParams = Pick<useReadTimeQuery$variables, 'includeContentBody' | 'status'> & {
	contentId: useReadTimeQuery$variables['contentId'];
	useCache: boolean;
};

export function preloadReadTime({
	contentId,
	includeContentBody = true,
	status,
	useCache,
}: PreloadReadTimeParams): Promise<{
	data: useReadTimeQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<useReadTimeQuery$data, useReadTimeQuery$variables>({
		query: ReadTimeQuery,
		variables: {
			contentId,
			includeContentBody,
			status,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
